import { render, staticRenderFns } from "./RelatorioCargaDescargaListFiltroModalItemInputSubProduto.vue?vue&type=template&id=22a17278"
import script from "./RelatorioCargaDescargaListFiltroModalItemInputSubProduto.vue?vue&type=script&lang=js"
export * from "./RelatorioCargaDescargaListFiltroModalItemInputSubProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports